import { mapActions } from "vuex";
import AddressForm from '@/components/FormsComponents/Address.vue'
import BuildProposed from '@/components/FormsComponents/WaterScanStepsSimplified/BuildProposed.vue'
import LocationInformation from '@/components/FormsComponents/WaterScanStepsSimplified/LocationInformation.vue'
import ProgressBar from '@/components/ProgressBar/ProgressBar.vue'
import StepsBar from '@/components/StepsBar/StepsBar.vue'
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"

export default {

  name: "NewWaterScan",
  components: {
    LocationInformation,
    BuildProposed,
    ProgressBar,
    StepsBar,
    AddressForm,
  },
  props: ['openNewProposalSimplified', 'closeFunc', 'registration', 'idProposal', 'viewOrEdit'],
  data: function () {
    return {
      closeAllPages: true,
      requestSave: false,
      validFormPag1: false,
      validFormPag2: false,
      validFormPag3: false,
      validFormPag4: false,
      open: false,
      advance: [],
      overlay: false,
      statusPos: 1,
      widthScreen: 0,
      enrollDialog: false,
      infoAlerts: 0,
      isPwsVisible: false,
      modensAlert: [],
      enrollObj: {
        locationInformation: [],
        checkList: [],
        historicConsumption: [],
      },
      statusProgress: [
        { id: 1, active: true, name: 'Cadastro' },
        { id: 2, active: false, name: 'Proposta' }],
      positionStep: 0,
      selectStep: 1,
      steps: ['Cadastro', 'Proposta'],
      enableStepWarn: [],
      nextStep: 0,

      saveLocaleInfo: false,
      saveChecklist: false,
      saveHistoryc: false,
      saveBuildProposal: false,

    }
  },
  computed: {},
  methods: {
    ...mapActions([
      'createChannel',
      'closeChannel',
    ]),
    async saveProposal() {
      switch (this.positionStep) {
        case 0:
          await this.$refs.LocationInformation.resquetEvent(this.positionStep, true)
          break;
        case 1:
          if (this.enableStepWarn.find((p) => p === 0)) {
            showErrorSnackBar(`Preencha o cadastro para concluir a proposta!`)
            return
          }
          await this.$refs.BuildProposed.updateProposalinFirebase()
          break;
        default:
          break;
      }
      if (this.enableStepWarn.length > 0) {
        showErrorSnackBar(`Existem campos pendentes!`)
        return
      }
      this.clearDisplay();

    },
    clearDisplay() {
      this.closeFunc();
      this.enableStepWarn = []
      this.closeAllPages = false
    },
    async validFormPages(valid, page) {
      this.overlay = false
      if (valid) {
        this.enableStepWarn = this.enableStepWarn.filter(stepWarn => stepWarn != page)
      } else {
        this.enableStepWarn.push(page)
      }
    },
  },
  watch: {
    openNewProposalSimplified(newValue) {
      this.closeAllPages = newValue
    },
    async positionStep(position) {
      let locationInfoValid = await this.$refs.LocationInformation.resquetEvent(position)
      if (!this.viewOrEdit && locationInfoValid === false) {
        showErrorSnackBar("Preencha os dados de Cadastro!!")
      } else {
        await this.$refs.BuildProposed.getCurrentProposal(position)
        this.nextStep = position
      }
    }
  },
  // created() {
  //   this.createChannel({ channel: 'waterscan' })
  // },
  // beforeDestroy() {
  //   this.closeChannel({ channel: 'waterscan' })
  // },
};